export default {"src":"/_next/static/media/fr.4567f5f8.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};